import { RemoveItemsFromGalleryFnReq, RemoveItemsFromGalleryFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

export class RemoveItemsFromGalleryInteractor {
  private readonly fn = httpsCallable<RemoveItemsFromGalleryFnReq, RemoveItemsFromGalleryFnRes>(
    this.functions,
    'removeItemsFromGallery',
  );

  constructor(private readonly functions: Functions) {}

  public async execute(galleryId: string, itemIds: string[]): Promise<RemoveItemsFromGalleryFnRes> {
    const res = await this.fn({ galleryId, itemIds });
    return res.data;
  }
}
